const scope = "scenarioAnalysis";
export default scope;